//
import React, { useCallback, useEffect, useState } from "react";
import { WhisperSpinner } from "react-spinners-kit";
import { useHistory } from "react-router-dom";
import { PieChart, Series, Label, Legend } from "devextreme-react/pie-chart";
import { Box, Headline, Row, Subtitle, ContainerLoading } from "./styles";
import pdsGroups from "../../config/pdsGroups";
import { useMemo } from "react";
import api from "../../services/api";
import { useAuth } from "../../hooks/auth";
import { datadogRum } from "@datadog/browser-rum";

export default function Home() {
  const { user, hasScope } = useAuth();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState({});

  const isAdmin = useMemo(() => {
    return hasScope([pdsGroups.Admin]);
  }, [hasScope]);

  datadogRum.setUser({
    id: user?.professionalId?.toString() || "",
    name: user?.userName || "",
    email: user?.email || "",
  });
  const loadDashboardData = useCallback(async () => {
    setLoading(true);
    const { data } = await api.get("api/dashboard");
    setDashboardData(data);
    setLoading(false);
  }, []);

  useEffect(() => {
    loadDashboardData();
  }, [loadDashboardData]);

  const handlePush = (link) => {
    history.push(link);
  };

  return (
    <>
      {loading ? (
        <ContainerLoading>
          <WhisperSpinner size={50} color="#8b0304" backColor="#8b0304" />
        </ContainerLoading>
      ) : (
        <div>
          <h1
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              color: "#333",
              marginBottom: 25,
            }}
          >
            Welcome {user?.userName ?? "to the Professional Development System"}
            !
          </h1>
          <Row>
            <Box onClick={() => handlePush("/toevaluate/")}>
              <Subtitle>Pending Evaluations</Subtitle>
              <Headline>{dashboardData?.evaluationsCount || 0}</Headline>
            </Box>

            <Box onClick={() => handlePush("/toevaluate/")}>
              <Subtitle>Pending Inputs for Senior Evaluation</Subtitle>
              <Headline>{dashboardData.seniorEvaluationsCount || 0}</Headline>
            </Box>

            <Box onClick={() => handlePush("/mentorint/")}>
              <Subtitle>Mentorint</Subtitle>
              <Subtitle
                style={{
                  lineHeight: "8px",
                  fontSize: "12px",
                  marginTop: "-6px",
                }}
              >
                (last talk)
              </Subtitle>
              <Headline>
                {dashboardData?.lastMentorintTalk
                  ? new Intl.DateTimeFormat("en-US", {
                      month: "short",
                      day: "2-digit",
                      year: "numeric",
                    }).format(new Date(dashboardData?.lastMentorintTalk))
                  : ""}
              </Headline>
            </Box>

            <Box onClick={() => handlePush("/mentorint/")}>
              <Subtitle>My Mentees</Subtitle>
              <Headline>{dashboardData?.mentoreesCount || 0}</Headline>
            </Box>
          </Row>
          <Row>
            <Box onClick={() => handlePush("/dosanddonts/")}>
              <Subtitle>Dos & Don’ts</Subtitle>
              <Subtitle
                style={{
                  lineHeight: "8px",
                  fontSize: "12px",
                  marginTop: "-6px",
                }}
              >
                (last update)
              </Subtitle>
              <Headline>
                {dashboardData?.dosDontsLastUpdate
                  ? new Intl.DateTimeFormat("en-US", {
                      month: "short",
                      day: "2-digit",
                      year: "numeric",
                    }).format(new Date(dashboardData?.dosDontsLastUpdate))
                  : ""}
              </Headline>
            </Box>

            <Box onClick={() => handlePush("/counseling/")}>
              <Subtitle>Current Year's Counseling</Subtitle>
              <Subtitle
                style={{
                  lineHeight: "8px",
                  fontSize: "12px",
                  marginTop: "-6px",
                }}
              >
                (is filled?)
              </Subtitle>
              <Headline>
                {(dashboardData?.isCurrentYearCounselingFilled || false) ===
                true
                  ? "Yes"
                  : "No"}
              </Headline>
            </Box>
            <Box onClick={() => handlePush("/tutorship/")}>
              <Subtitle>Tutorship</Subtitle>
              <Subtitle
                style={{
                  lineHeight: "8px",
                  fontSize: "12px",
                  marginTop: "-6px",
                }}
              >
                (last talk)
              </Subtitle>
              <Headline>
                {dashboardData?.lastTutorshipTalkDate
                  ? new Intl.DateTimeFormat("en-US", {
                      month: "short",
                      day: "2-digit",
                      year: "numeric",
                    }).format(new Date(dashboardData?.lastTutorshipTalkDate))
                  : ""}
              </Headline>
            </Box>
          </Row>
          {isAdmin && (
            <>
              <Row>
                <Box
                  style={{ height: "auto" }}
                  onClick={() => handlePush("/allevaluations/")}
                >
                  <Headline style={{ textAlign: "center", marginTop: 10 }}>
                    Consultancy Evaluations Status
                  </Headline>
                  <Subtitle style={{ textAlign: "center" }}>
                    (active cycles)
                  </Subtitle>
                  {dashboardData.consultancyEvaluationsInDraft === 0 &&
                  dashboardData.consultancyEvaluationsInValidation === 0 &&
                  dashboardData.consultancyEvaluationsWaitingDiscussion === 0 &&
                  dashboardData.consultancyEvaluationsWaitingFinalComments ===
                    0 &&
                  dashboardData.consultancyEvaluationsCompleted === 0 ? (
                    <p style={{ textAlign: "center", marginTop: 50 }}>
                      No data
                    </p>
                  ) : (
                    <PieChart
                      style={{ alignSelf: "center" }}
                      id="consultancyEvaluationsPie"
                      dataSource={[
                        {
                          status: "Draft",
                          value: dashboardData.consultancyEvaluationsInDraft,
                        },
                        {
                          status: "Waiting Validation",
                          value:
                            dashboardData.consultancyEvaluationsInValidation,
                        },
                        {
                          status: "Waiting Professional Discussion",
                          value:
                            dashboardData.consultancyEvaluationsWaitingDiscussion,
                        },
                        {
                          status: "Waiting Final Comments",
                          value:
                            dashboardData.consultancyEvaluationsWaitingFinalComments,
                        },
                        {
                          status: "Completed",
                          value: dashboardData.consultancyEvaluationsCompleted,
                        },
                      ]}
                      size={{ width: 400, height: 400 }}
                      resolveLabelOverlapping={"shift"}
                      customizePoint={(point) => {
                        switch (point.argument) {
                          case "Draft":
                            return { color: "rgb(204, 204, 204)" };
                          case "Waiting Validation":
                            return { color: "rgb(209, 92, 86)" };
                          case "Waiting Professional Discussion":
                            return { color: "rgb(237, 206, 97)" };
                          case "Waiting Final Comments":
                            return { color: "rgb(82, 185, 217)" };
                          case "Completed":
                            return { color: "rgb(76, 181, 111)" };
                          default:
                            return {};
                        }
                      }}
                    >
                      <Series argumentField="status" valueField="value">
                        <Label
                          visible={true}
                          customizeText={(e) => {
                            if (e.value > 0)
                              return `${e.argumentText} - ${e.value} (${e.percentText})`;
                          }}
                        />
                      </Series>
                      <Legend visible={false} />
                    </PieChart>
                  )}
                </Box>

                <Box
                  style={{ height: "auto" }}
                  onClick={() => handlePush("/allevaluations/")}
                >
                  <Headline style={{ textAlign: "center", marginTop: 10 }}>
                    Corporate Evaluations Status
                  </Headline>
                  <Subtitle style={{ textAlign: "center" }}>
                    (active cycles)
                  </Subtitle>
                  {dashboardData.corporateEvaluationsInDraft === 0 &&
                  dashboardData.corporateEvaluationsInValidation === 0 &&
                  dashboardData.corporateEvaluationsWaitingDiscussion === 0 &&
                  dashboardData.corporateEvaluationsWaitingFinalComments ===
                    0 &&
                  dashboardData.corporateEvaluationsCompleted === 0 ? (
                    <p style={{ textAlign: "center", marginTop: 50 }}>
                      No data
                    </p>
                  ) : (
                    <PieChart
                      style={{ alignSelf: "center" }}
                      id="corporateEvaluationsPie"
                      dataSource={[
                        {
                          status: "Draft",
                          value: dashboardData.corporateEvaluationsInDraft,
                        },
                        {
                          status: "Waiting Validation",
                          value: dashboardData.corporateEvaluationsInValidation,
                        },
                        {
                          status: "Waiting Professional Discussion",
                          value:
                            dashboardData.corporateEvaluationsWaitingDiscussion,
                        },
                        {
                          status: "Waiting Final Comments",
                          value:
                            dashboardData.corporateEvaluationsWaitingFinalComments,
                        },
                        {
                          status: "Completed",
                          value: dashboardData.corporateEvaluationsCompleted,
                        },
                      ]}
                      size={{ width: 400, height: 400 }}
                      resolveLabelOverlapping={"shift"}
                      customizePoint={(point) => {
                        switch (point.argument) {
                          case "Draft":
                            return { color: "rgb(204, 204, 204)" };
                          case "Waiting Validation":
                            return { color: "rgb(209, 92, 86)" };
                          case "Waiting Professional Discussion":
                            return { color: "rgb(237, 206, 97)" };
                          case "Waiting Final Comments":
                            return { color: "rgb(82, 185, 217)" };
                          case "Completed":
                            return { color: "rgb(76, 181, 111)" };
                          default:
                            return {};
                        }
                      }}
                    >
                      <Series argumentField="status" valueField="value">
                        <Label
                          visible={true}
                          customizeText={(e) => {
                            if (e.value > 0)
                              return `${e.argumentText} - ${e.value} (${e.percentText})`;
                          }}
                        />
                      </Series>
                      <Legend visible={false} />
                    </PieChart>
                  )}
                </Box>
              </Row>
              <Row>
                <Box
                  style={{ height: "auto" }}
                  onClick={() => handlePush("/toevaluate/")}
                >
                  <Headline style={{ textAlign: "center", marginTop: 10 }}>
                    Partner Inputs Status
                  </Headline>
                  <Subtitle style={{ textAlign: "center" }}>
                    (active cycles)
                  </Subtitle>
                  {dashboardData.evaluationSeniorProjectsPartnerInputsPending ===
                    0 &&
                  dashboardData.evaluationSeniorProjectsPartnerInputsCompleted ===
                    0 ? (
                    <p style={{ textAlign: "center", marginTop: 50 }}>
                      No data
                    </p>
                  ) : (
                    <PieChart
                      style={{ alignSelf: "center" }}
                      id="partnersInputsPie"
                      dataSource={[
                        {
                          status: "Pending",
                          value:
                            dashboardData.evaluationSeniorProjectsPartnerInputsPending,
                        },
                        {
                          status: "Done",
                          value:
                            dashboardData.evaluationSeniorProjectsPartnerInputsCompleted,
                        },
                      ]}
                      size={{ width: 400, height: 400 }}
                      resolveLabelOverlapping={"shift"}
                      customizePoint={(point) => {
                        switch (point.argument) {
                          case "Pending":
                            return { color: "rgb(209, 92, 86)" };
                          case "Done":
                            return { color: "rgb(76, 181, 111)" };
                          default:
                            return {};
                        }
                      }}
                    >
                      <Series argumentField="status" valueField="value">
                        <Label
                          visible={true}
                          customizeText={(e) => {
                            if (e.value > 0)
                              return `${e.argumentText} - ${e.value} (${e.percentText})`;
                          }}
                        />
                      </Series>
                      <Legend visible={false} />
                    </PieChart>
                  )}
                </Box>

                <Box
                  style={{ height: "auto" }}
                  onClick={() => handlePush("/toevaluate/")}
                >
                  <Headline style={{ textAlign: "center", marginTop: 10 }}>
                    Team Inputs Status
                  </Headline>
                  <Subtitle style={{ textAlign: "center" }}>
                    (active cycles)
                  </Subtitle>
                  {dashboardData.evaluationSeniorProjectsTeamInputsPending ===
                    0 &&
                  dashboardData.evaluationSeniorProjectsTeamInputsCompleted ===
                    0 ? (
                    <p style={{ textAlign: "center", marginTop: 50 }}>
                      No data
                    </p>
                  ) : (
                    <PieChart
                      style={{ alignSelf: "center" }}
                      id="teamInputsPie"
                      dataSource={[
                        {
                          status: "Pending",
                          value:
                            dashboardData.evaluationSeniorProjectsTeamInputsPending,
                        },
                        {
                          status: "Done",
                          value:
                            dashboardData.evaluationSeniorProjectsTeamInputsCompleted,
                        },
                      ]}
                      size={{ width: 400, height: 400 }}
                      resolveLabelOverlapping={"shift"}
                      customizePoint={(point) => {
                        switch (point.argument) {
                          case "Pending":
                            return { color: "rgb(209, 92, 86)" };
                          case "Done":
                            return { color: "rgb(76, 181, 111)" };
                          default:
                            return {};
                        }
                      }}
                    >
                      <Series argumentField="status" valueField="value">
                        <Label
                          visible={true}
                          customizeText={(e) => {
                            if (e.value > 0)
                              return `${e.argumentText} - ${e.value} (${e.percentText})`;
                          }}
                        />
                      </Series>
                      <Legend visible={false} />
                    </PieChart>
                  )}
                </Box>

                <Box
                  style={{ height: "auto" }}
                  onClick={() => handlePush("/toevaluate/")}
                >
                  <Headline style={{ textAlign: "center", marginTop: 10 }}>
                    Mentee Inputs Status
                  </Headline>
                  <Subtitle style={{ textAlign: "center" }}>
                    (active cycles)
                  </Subtitle>
                  {dashboardData.evaluationSeniorMenteesPending === 0 &&
                  dashboardData.evaluationSeniorMenteesCompleted === 0 &&
                  dashboardData.evaluationSeniorMenteesNA === 0 ? (
                    <p style={{ textAlign: "center", marginTop: 50 }}>
                      No data
                    </p>
                  ) : (
                    <PieChart
                      style={{ alignSelf: "center" }}
                      id="teamInputsPie"
                      dataSource={[
                        {
                          status: "Pending",
                          value: dashboardData.evaluationSeniorMenteesPending,
                        },
                        {
                          status: "Done",
                          value: dashboardData.evaluationSeniorMenteesCompleted,
                        },
                        {
                          status: "N/A",
                          value: dashboardData.evaluationSeniorMenteesNA,
                        },
                      ]}
                      size={{ width: 400, height: 400 }}
                      resolveLabelOverlapping={"shift"}
                      customizePoint={(point) => {
                        switch (point.argument) {
                          case "Pending":
                            return { color: "rgb(209, 92, 86)" };
                          case "Done":
                            return { color: "rgb(76, 181, 111)" };
                          case "N/A":
                            return { color: "rgb(204, 204, 204)" };
                          default:
                            return {};
                        }
                      }}
                    >
                      <Series argumentField="status" valueField="value">
                        <Label
                          visible={true}
                          customizeText={(e) => {
                            if (e.value > 0)
                              return `${e.argumentText} - ${e.value} (${e.percentText})`;
                          }}
                        />
                      </Series>
                      <Legend visible={false} />
                    </PieChart>
                  )}
                </Box>
              </Row>
            </>
          )}
        </div>
      )}
    </>
  );
}
